import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CLAIMLINES_FEATURE_KEY,
  ClaimLinesState,
  claimLineEntityAdapter
} from './claim-lines.reducer';

// Lookup the 'ClaimLines' feature state managed by NgRx
const getClaimLinesState = createFeatureSelector<ClaimLinesState>(
  CLAIMLINES_FEATURE_KEY
);

export const {
  selectIds: getClaimLineIds,
  selectEntities: getClaimLineEntities,
  selectAll: getAllClaimLines,
  selectTotal: getTotalClaimLines
} = claimLineEntityAdapter.getSelectors(getClaimLinesState);

const getLoaded = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.loaded
);

const getLoading = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.loading
);

const getError = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.error
);

const getSelectedId = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.selectedId
);

const getSelectedIds = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.selectedIds
);

const getSelectedByStatusId = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.selectedByStatusIds
);

const getSelectedByAssigneeId = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.selectedByAssigneeIds
);

const getSelectedByCurrentUserId = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.selectedByCurrentUserIds
);

const getSelectedByStatusPage = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.selectedByStatusPage
);

const getSelectedByAssigneePage = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.selectedByAssigneePage
);

const getSelectedByCurrentUserPage = createSelector(
  getClaimLinesState,
  (state: ClaimLinesState) => state.selectedByCurrentUserPage
);

const getSelectedClaimLine = createSelector(
  getClaimLineEntities,
  getSelectedId,
  (claimLines, id) => {
    const result = claimLines[id];
    return result ? Object.assign({}, result) : undefined;
  }
);

const getSelectedClaimLines = createSelector(
  getClaimLineEntities,
  getSelectedIds,
  (claimLines, ids) => {
    const result = ids.map(id => claimLines[id]);
    return result ? Object.assign([], result) : [];
  }
);

const getSelectedByStatusClaimLines = createSelector(
  getClaimLineEntities,
  getSelectedByStatusId,
  (claimLines, ids) => {
    const result = ids.map(id => claimLines[id]);
    return result ? Object.assign([], result) : [];
  }
);

const getSelectedByAssigneeClaimLines = createSelector(
  getClaimLineEntities,
  getSelectedByAssigneeId,
  (claimLines, ids) => {
    const result = ids.map(id => claimLines[id]);
    return result ? Object.assign([], result) : [];
  }
);

const getSelectedByCurrentUserClaimLines = createSelector(
  getClaimLineEntities,
  getSelectedByCurrentUserId,
  (claimLines, ids) => {
    const result = ids.map(id => claimLines[id]);
    return result ? Object.assign([], result) : [];
  }
);

export const claimLinesQuery = {
  getLoaded,
  getLoading,
  getError,
  getAllClaimLines,
  getSelectedByStatusPage,
  getSelectedByAssigneePage,
  getSelectedByCurrentUserPage,
  getSelectedClaimLine,
  getSelectedClaimLines,
  getSelectedByStatusClaimLines,
  getSelectedByAssigneeClaimLines,
  getSelectedByCurrentUserClaimLines
};
